var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNotification = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.462,
    height: 24,
    viewBox: "0 0 18.462 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.231 3a1.845 1.845 0 0 0-1.846 1.846 1.614 1.614 0 0 0 .029.231 7.405 7.405 0 0 0-5.567 7.154v8.308a.907.907 0 0 1-.923.923H6v1.846h6.635a2.723 2.723 0 0 0-.173.923 2.769 2.769 0 1 0 5.538 0 2.723 2.723 0 0 0-.173-.923h6.635v-1.846h-.923a.907.907 0 0 1-.923-.923V12.49a7.652 7.652 0 0 0-5.567-7.413 1.614 1.614 0 0 0 .029-.231A1.845 1.845 0 0 0 15.231 3zm-.4 3.692c.133-.011.267 0 .4 0h.169a5.707 5.707 0 0 1 5.365 5.8v8.048a2.723 2.723 0 0 0 .173.923H9.519a2.723 2.723 0 0 0 .173-.923v-8.309a5.543 5.543 0 0 1 5.135-5.539zm.4 16.615a.923.923 0 1 1-.923.923.911.911 0 0 1 .923-.922z",
    transform: "translate(-6 -3)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotification, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/notification.6757698c.svg";
export { ForwardRef as ReactComponent };